export default __webpack_public_path__ + "static/media/ratingFilled.60263ee8.svg";